import { IMAGE_GENERATION_FORM_DEFAULTS } from './ImageGenerationFormState';
import { VIDEO_GENERATION_FORM_DEFAULTS } from './VideoGenerationFormState';
import { getImageGenerationCreditCost, getVideoGenerationCreditCost, VIDEO_EDIT_CREDIT_COST } from './constants';
import { type AiToolkitCategory, type AiToolkitFormStates, AI_TOOLKIT_CATEGORIES } from './types';

export const getCreditCost = (category: AiToolkitCategory, formStates: AiToolkitFormStates): number => {
    switch (category) {
        case AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION: {
            const duration = Number(formStates[category]?.duration ?? VIDEO_GENERATION_FORM_DEFAULTS.duration);
            return getVideoGenerationCreditCost(duration);
        }
        case AI_TOOLKIT_CATEGORIES.IMAGE_GENERATION: {
            const resolution = formStates[category]?.resolution ?? IMAGE_GENERATION_FORM_DEFAULTS.resolution;
            return getImageGenerationCreditCost(resolution);
        }
        case AI_TOOLKIT_CATEGORIES.VIDEO_EDIT:
            return VIDEO_EDIT_CREDIT_COST;
        case AI_TOOLKIT_CATEGORIES.VOICEOVER:
            return 0;
    }
};
